"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const state_1 = __importDefault(require("../state"));
const hasPausedSinceClaw = () => {
    if (state_1.default.pauses.length > 0) {
        return state_1.default.pauses[state_1.default.pauses.length - 1].pausedAt >= state_1.default.recentDestruction.clawedAt;
    }
    return false;
};
exports.default = hasPausedSinceClaw;
